import React from 'react'
import * as Sentry from '@sentry/node'
import {AppProps} from 'next/app'
import {appWithTranslation} from 'next-i18next'
import {Amplify} from '@aws-amplify/core'

import {TemplatesThemeProvider} from '@miro-site/templates-design'
import {ServicesProvider} from '@miro-site/services'

import nextI18nextConfig from '../next-i18next.config'
import awsExports from '../src/aws-exports'
import useRouterScroll from '../src/hooks/useRouterScroll'

import '../src/utils/polyfills'
import '../public/static/styles/one-trust-cookie-banner.css'

Amplify.configure({...awsExports})

if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
  Sentry.init({
    enabled: Boolean(Number(process.env.NEXT_PUBLIC_SENTRY_ENABLE)),
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  })
}

const Templates = (props: AppProps): JSX.Element => {
  const {Component, pageProps, err} = props as AppProps & {
    err: unknown
  }

  useRouterScroll()

  return (
    <ServicesProvider>
      <TemplatesThemeProvider>
        <Component {...pageProps} err={err} />
      </TemplatesThemeProvider>
    </ServicesProvider>
  )
}

export default appWithTranslation(Templates, nextI18nextConfig)
